import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import JobDetailPage from './pages/JobDetailPage';
import HowItWorksPage from './pages/HowItWorksPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import CvBuilderPage from './pages/CvBuilderPage';
import ReportsPage from './pages/ReportsPage';
import MockInterviewPage from './pages/MockInterviewPage';
import ApplicationsPage from './pages/ApplicationsPage';
import MeetingNotesPage from './pages/MeetingNotesPage';
import MagicLinkPage from './pages/MagicLinkPage';
import GoogleCallbackPage from './pages/GoogleCallbackPage';
import LinkedInCallbackPage from './pages/LinkedInCallbackPage';
import './App.css';

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/nasil-calisir" element={<HowItWorksPage />} />
            <Route path="/ilan/:slug" element={<JobDetailPage />} />
            <Route path="/giris" element={<LoginPage />} />
            <Route path="/auth/magic-link" element={<MagicLinkPage />} />
            <Route path="/auth/google/callback" element={<GoogleCallbackPage />} />
            <Route path="/auth/linkedin/callback" element={<LinkedInCallbackPage />} />
            <Route path="/panel" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/panel/profil" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/panel/cv-olustur" element={<ProtectedRoute><CvBuilderPage /></ProtectedRoute>} />
            <Route path="/panel/raporlar" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
            <Route path="/panel/basvurularim" element={<ProtectedRoute><ApplicationsPage /></ProtectedRoute>} />
            <Route path="/panel/toplantilarim" element={<ProtectedRoute><MeetingNotesPage /></ProtectedRoute>} />
            <Route path="/panel/mulakat" element={<ProtectedRoute><MockInterviewPage /></ProtectedRoute>} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
